module.exports = __webpack_public_path__ + "static/media/Athelstan 3.772f4d01.jpg";